import { Box } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import HeaderMobile from 'Component/header-mobile';
import { Condition } from 'Component/others';
import SwitchTab from 'UiKit/switch-tab';

import Calendar from 'View/host-schedule/section/calendar';
import FilterCalendar from 'View/host-schedule/section/filter-calendar';
import FilterList from 'View/host-schedule/section/filter-list';
import ScheduleList from 'View/host-schedule/section/schedule-list';
import useGetHeaderTitle from 'View/host-schedule/hook/useGetHeaderTitle';
import tabOption from 'View/host-schedule/const/tabOption';
import useResetState from 'View/host-schedule/hook/useResetStore';
import HostScheduleProvider, { useHostScheduleState } from 'View/host-schedule/state';

import styles from './styles.module.css';

const HostSchedule = () => {
  const { state, updateState, resetFilterState } = useHostScheduleState();
  const navigate = useNavigate();
  const resetStateHandler = useResetState();

  const headerTitle = useGetHeaderTitle();

  const onChangeSwitchTab = (selectedView) => {
    updateState({ selectedView });
    resetFilterState();
  };

  useEffect(() => resetStateHandler(), /* eslint-disable */ []);

  return (
    <Box className={styles['host-schedule__container']}>
      <HeaderMobile type="header-back" title={headerTitle} onClick={() => navigate('/host')} />

      <Box className={styles['filter__section']}>
        <SwitchTab
          options={tabOption}
          value={state?.selectedView}
          handleChange={(selectedView) => onChangeSwitchTab(selectedView)}
          variant="line"
          className={styles['switch-tab']}
        />

        <Condition statement={state?.selectedView === 'card'}>
          <FilterList />
        </Condition>

        <Condition statement={state?.selectedView === 'calendar'}>
          <FilterCalendar />
        </Condition>
      </Box>

      <Box className={styles['content__section']}>
        <Condition statement={state?.selectedView === 'card'}>
          <ScheduleList />
        </Condition>

        <Condition statement={state?.selectedView === 'calendar'}>
          <Calendar />
        </Condition>
      </Box>
    </Box>
  );
};

const HostScheduleContainer = () => <HostScheduleProvider children={<HostSchedule />} />;

export default HostScheduleContainer;
